import { useState, useEffect } from "react";

const useEventData = () => {
  const [eventsArrFromAPI, setEventsArrFromAPI] = useState([]);

  useEffect(() => {
    const url = `${process.env.REACT_APP_DEV_BASE_URL}/events/`;

    const requestOptions = (token) => {
      return {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          client_token: "ebd86470-7e90-4ece-9e89-1b6d4d2cbb61",
        },
      };
    };
    const fetchData = async () => {
      try {
        const response = await fetch(url, requestOptions());
        const json = await response.json();
        // console.log(json);
        setEventsArrFromAPI(json.data.events);
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, []);

  return [eventsArrFromAPI];
};

export default useEventData;
